import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { pick } from 'lodash'

/**
 * Функция загрузки отчета
 */
const useLoadCabinetReportInventory = (data: any) => {
  const http = useHttp()
  const route = useRoute()
  const params = ['meter']

  const url = computed(() => {
    const searchParams = new URLSearchParams(pick(data, params))
    return `/reports/cabinet/${route.params.object_id}/inventory?${searchParams}`
  })

  const queryKey = computed(() => ['load_cabinet_report_inventory', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: false,
  })
}

export { useLoadCabinetReportInventory }
